import { render, staticRenderFns } from "./admin-courseware-editor.vue?vue&type=template&id=21a91ccd&"
import script from "./admin-courseware-editor.vue?vue&type=script&lang=js&"
export * from "./admin-courseware-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports